document.addEventListener('DOMContentLoaded', () => {
  // HOW TO FIND US POPUP
  const how_to_find_us_button = document.getElementById('how-to-find-us-button');
  const how_to_find_us_popup = document.getElementById('how-to-find-us-popup');

  if (how_to_find_us_button && how_to_find_us_popup) {
    how_to_find_us_button.addEventListener('click', () => {
      how_to_find_us_popup.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    });
  }

  // GUARANTEE POPUP BLOCK
  const guarantee_popup_block_open_button = document.getElementById('block-guarantee-popup-open-button');
  const guarantee_popup_block_wrapper = document.getElementById('block-guarantee-popup-wrapper');
  const guarantee_popup_block_close_button = document.getElementById('block-guarantee-popup-close-button');

  if (guarantee_popup_block_open_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_open_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.remove('hidden');
    });
  }

  if (guarantee_popup_block_close_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_close_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.add('hidden');
    });
  }

  // VARIABLES
  const sectionWrapper = document.getElementById('section-wrapper');
  const addToCartText = sectionWrapper.dataset.addToCartText;
  const chooseColorText = sectionWrapper.dataset.chooseColorText; 
  const placeholder_color_name = sectionWrapper.dataset.placeholderColorName;
  
  // KEENSLIDER
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    };
  }

  const product_slider_slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
  product_slider_slides.forEach((slide) => {
    slide.classList.remove("hidden", "mr-[10px]");
  });

  const product_large_slider = new KeenSlider(
    "#product-keen-large-slider", 
    {
      loop: false,
      slides: {
        spacing: 8,
        perView: 1.1,
      },
    }
  );

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
        loop: false,
        slides: {
          spacing: 10,
          perView: 6,
        },
        vertical: false,
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // NAIL PICKER COLOR SCROLL THUMB
  document.querySelectorAll('.nail-picker-color').forEach(card => {
    const content = card.querySelector('.scroll-content');
    const thumb = card.querySelector('.fake-thumb');
    const bar = thumb.parentElement;
  
    if (!content || !thumb) return;
  
    function updateThumb() {
      const maxScroll = content.scrollWidth - content.clientWidth;
  
      const ratio = content.scrollLeft / maxScroll;
      const maxX = bar.clientWidth - thumb.offsetWidth;
  
      thumb.style.transform = `translateX(${ratio * maxX}px)`;
    }
  
    content.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
  
    updateThumb();
  });

  // CUSTOM STICKY ATC BUTTON
  const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
  const stickyButton = document.getElementById('byteex-stycky-atc-button');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');
  const nail_picker = document.getElementById('nail_picker');  
  const productForm = document.querySelector('form[action$="/cart/add"]');
  const submitButton = productForm?.querySelector('button');

  if (stickyButtonWrapper && stickyButtonText && productForm && submitButton) {
    const scrollToElement = (el, offset = 0) => {
      const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      } else {
        window.scrollTo(0, targetY);
      }
    };

    if (submitButton.getAttribute('type') === 'button') {
      stickyButtonText.innerText = chooseColorText;
    } else {
      stickyButtonText.innerText = addToCartText;
    }

    stickyButtonWrapper.addEventListener('click', () => {
      scrollToElement(nail_picker, 200);
    });

    const checkButtonPosition = () => {
      const currentSubmitButton = productForm.querySelector('button');
      const buttonRect = currentSubmitButton.getBoundingClientRect();
      if (buttonRect.bottom <= 70) {
        stickyButtonWrapper.style.transform = 'translateY(0px)';
      } else {
        stickyButtonWrapper.style.transform = 'translateY(140px)';
      }
    };

    window.addEventListener('scroll', checkButtonPosition);

    stickyButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const stickyLoader = document.getElementById('sticky_atc_button_loader');
      const loaderDisplayStyle = window.getComputedStyle(stickyLoader).display;
      const currentSubmitButton = productForm.querySelector('button');

      if (currentSubmitButton.getAttribute('type') === 'submit' && loaderDisplayStyle === 'none') {
        currentSubmitButton.click();
      } else {
        scrollToElement(nail_picker, 200);
      }
    });

    const buttonObserver = new MutationObserver(() => {
      const button = productForm.querySelector('button');
      if (!button) return;
      if (button.getAttribute('type') === 'submit') {
        stickyButtonText.innerText = addToCartText;
      } else {
        stickyButtonText.innerText = chooseColorText;
      }
    });

    buttonObserver.observe(submitButton, { attributes: true });
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById('two-video-block-button-1');
  const two_video_block_button_2 = document.getElementById('two-video-block-button-2');
  const two_video_block_video_1 = document.getElementById('two-video-block-video-1');
  const two_video_block_video_2 = document.getElementById('two-video-block-video-2');

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener('click', () => {
      two_video_block_video_1.classList.remove('hidden');
      two_video_block_video_2.classList.add('hidden');
      two_video_block_button_1.style.borderBottom = 'thin solid #211912';
      two_video_block_button_2.style.borderBottom = 'none';
    });

    two_video_block_button_2.addEventListener('click', () => {
      two_video_block_video_1.classList.add('hidden');
      two_video_block_video_2.classList.remove('hidden');
      two_video_block_button_1.style.borderBottom = 'none';
      two_video_block_button_2.style.borderBottom = 'thin solid #211912';
    });
  }

  const selected_colors = document.querySelectorAll('.nail-picker-selected-color'); 
  const selected_colors_sticky_atc = document.querySelectorAll('.byteex-stycky-atc-selected-color'); 
  const selected_colors_inside_picker = document.querySelectorAll('.selected-colors-inside-picker'); 
  const selected_colors_last_step = document.querySelectorAll('.selected-colors-last-step');

  const nail_picker_last_step_popup = document.getElementById('nail-picker-last-step-popup');

  const hidden_overlay = document.getElementById('hidden-overlay');
  const color_items = document.querySelectorAll('.nail-picker-color');

  const remove_selected_colors = document.querySelectorAll('.remove-selected-color');
  const remove_selected_colors_on_picker = document.querySelectorAll('.remove-selected-color-on-picker');
  const remove_selected_colors_on_last_step = document.querySelectorAll('.remove-selected-color-on-last-step');

  const product_form = document.querySelector('.main-product-form');
  const main_atc_button = document.getElementById('byteex-submit-button');

  const atc_button_text = document.getElementById('atc-button-text');
  const choose_color_button_text = document.getElementById('choose-color-button-text');

  const variant_picker_data = document.getElementById('variant-picker-data');
  let colors_number = variant_picker_data.dataset.maxWrapsNumber;

  const variant_number_pre_selected = variant_picker_data.dataset.variantNumberPreSelected;
  const variant_number_pre_selected_number = Number(variant_number_pre_selected) - 1;

  const giftItems = document.querySelectorAll(".gift-item");

  const priceBlocks = document.querySelectorAll(".price-block");
  const priceAtc = document.querySelector(".price-atc");
  const nail_picker_title_wraps_number = document.getElementById('nail-picker-title-wraps-number'); 

  // VARIANT PICKER
  const variantPickerItems = document.querySelectorAll(".variant-picker-item");
  const variantMessage = document.getElementById('variant-message');

  const selected_colors_count_on_picker = document.querySelector('.selected-colors-count');
  const max_colors_number_on_picker = document.querySelector('.max-colors-number');

  // GET FREE COUNT FROM VARIANT TITLE
  /*function getFreeCount(str) {
    const match = str.match(/(\d+)\s*free/i);
    return match ? Number(match[1]) : null;
  }*/

  function getFreeCount(str) {
    const match = str.match(/\+\s*(\d+)/);
    return match ? Number(match[1]) : null;
  }

  const variants_upgrade_data = {};

  variantPickerItems.forEach((variant, idx, arr) => {
    // GET UPGRADE TEXT FOR VARIANT
    const wraps_number = variant.dataset.wrapsNumber;
    const upgrade_text = variant.dataset.upgradeText || 'No upgrade text';
    if (wraps_number && upgrade_text) {
      variants_upgrade_data[wraps_number] = upgrade_text;
    }

    // ADD CLICK EVENT TO VARIANT PICKER ITEM
    variant.addEventListener("click", (e) => {
      const current_item = e.currentTarget;

      const id = current_item.dataset.id;
      const giftCount = current_item.dataset.giftCount;
      const wrapsNumber = current_item.dataset.wrapsNumber;
      const message = current_item.dataset.message;
      const variantTitle = current_item.dataset.title;

      const freeCount = getFreeCount(variantTitle);

      max_colors_number_on_picker.textContent = wrapsNumber;

      if (variantMessage) {
        variantMessage.textContent = message;
      }

      if (nail_picker_title_wraps_number) {
        nail_picker_title_wraps_number.textContent = wrapsNumber;
      }

      priceBlocks.forEach((block, index) => {
        block.style.display = "none";

        if (idx === index) {
          block.style.display = "block";

          const priceBlockData = block.querySelector(".price-block-data");
          const price = priceBlockData.dataset.price;
          const comparePrice = priceBlockData.dataset.comparePrice;

          if (priceAtc.children[0]) {
            priceAtc.children[0].innerHTML = price;
          }

          if (priceAtc.children[1]) {
            priceAtc.children[1].innerHTML = comparePrice;
          }
        }
      });

      colors_number = Number(wrapsNumber) || 0;
      
      giftItems.forEach((item, idx) => {
        const image = item.querySelector("img");
        const svg = item.querySelector(".lock-icon");

        image.style.display = "block";
        svg.style.display = "none";

        if (idx > giftCount - 1) {
          image.style.display = "none";
          svg.style.display = "block";
        }
      });

      // ADD FREE LABEL TO SELECTED COLORS INSIDE PICKER
      selected_colors_inside_picker.forEach((color, idx) => {
        const free_label = color.querySelector('.selected-color-free-label-inside-picker');
        if (freeCount && idx <= colors_number - 1 && idx >= colors_number - freeCount) {
          free_label.style.display = 'block';
        } else {
          free_label.style.display = 'none';
        }
      });

      selected_colors.forEach((color, idx) => {
        const image = color.querySelector("img");
        const plus_icon = color.querySelector("span");
        const lock_icon = color.querySelector(".lock-icon");
        const remove_button = color.querySelector(".remove-selected-color");
        const color_name = color.querySelector("p");
        const isSelected = color.dataset.selected;
        const image_wrapper = color.firstElementChild;

        // ADD FREE LABEL TO MAIN SELECTED COLOR
        const free_label = color.querySelector('.nail-picker-selected-color-free-label');
        if (freeCount && idx <= colors_number - 1 && idx >= colors_number - freeCount) {
          free_label.style.display = 'block';
        } else {
          free_label.style.display = 'none';
        }    

        // RESTORE PLUS ICON AND REMOVE LOCK ICON FOR SELECTED COLORS
        if (!isSelected || isSelected === "false") {
          image.style.opacity = "1";
          plus_icon.style.display = "block";
          lock_icon.style.display = "none";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
            if (plus_icon) {
              plus_icon.style.display = "block";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }

          const current_selected_color_inside_picker = selected_colors_inside_picker[idx];
          if (current_selected_color_inside_picker) {
            const plus_icon = current_selected_color_inside_picker.querySelector('span');
            if (plus_icon) {
              plus_icon.style.display = "block";
            }

            const lock_icon = current_selected_color_inside_picker.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }
        }

        // CLEAR DATA FROM SELECTED COLOR IF COLORS MORE THAN SELECTED VARIANT
        if (idx > colors_number - 1) {
          color.removeAttribute("data-selected");
          color.removeAttribute("data-id");

          image.removeAttribute('src');
          image.classList.add('hidden');
          color_name.textContent = `${placeholder_color_name} ${idx + 1}`;          

          plus_icon.style.display = "none";
          lock_icon.style.display = "block";
          remove_button.style.display = "none";

          image_wrapper.style.backgroundColor = "#FAF7F5";
          image_wrapper.style.borderColor = "#2119124D";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const img = current_selected_colors_sticky_atc.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
            if (plus_icon) {
              plus_icon.style.display = "none";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            current_selected_colors_sticky_atc.style.backgroundColor = "#FAF7F5";
            current_selected_colors_sticky_atc.style.borderColor = "#2119124D";
          }

          const current_selected_colors_color_list = selected_colors_inside_picker[idx];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const plus_icon = current_selected_colors_color_list.querySelector('span');
            if (plus_icon) {
              plus_icon.style.display = "none";
            }

            const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            const remove_button = current_selected_colors_color_list.querySelector('.remove-selected-color-on-picker');
            if (remove_button) {
              remove_button.classList.add('hidden');
            }

            current_selected_colors_color_list.style.backgroundColor = "#FAF7F5";
            current_selected_colors_color_list.style.borderColor = "#2119124D";
          }

          const current_selected_colors_last_step = selected_colors_last_step[idx];
          if (current_selected_colors_last_step) {
            const img = current_selected_colors_last_step.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const lock_icon = current_selected_colors_last_step.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.classList.remove('hidden');
            }

            const remove_button = current_selected_colors_last_step.querySelector('.remove-selected-color-on-last-step');
            if (remove_button) {
              remove_button.classList.add('hidden');
            }

            const upgrade_button = current_selected_colors_last_step.querySelector('.selected-last-step-upgrade');
            if (upgrade_button) {
              upgrade_button.classList.remove('hidden');
            }

            current_selected_colors_last_step.style.cursor = "pointer";
          }
        } else {
          image_wrapper.style.backgroundColor = "#ffffff";
          image_wrapper.style.borderColor = "#211912B2";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            current_selected_colors_sticky_atc.style.backgroundColor = "#ffffff";
            current_selected_colors_sticky_atc.style.borderColor = "#211912B2";
          }

          const current_selected_colors_color_list = selected_colors_inside_picker[idx];
          if (current_selected_colors_color_list) {
            current_selected_colors_color_list.style.backgroundColor = "#ffffff";
            current_selected_colors_color_list.style.borderColor = "#211912B2";
          }

          const current_selected_colors_last_step = selected_colors_last_step[idx];
          if (current_selected_colors_last_step) {
            current_selected_colors_last_step.style.cursor = "default";
          }
        }
      });

      // UPDATE COLOR ITEM LIST WITH NEW SELECTED COLORS
      color_items.forEach(color_item => {
        const add_color_item_button = color_item.querySelector('.add-color-item-button');
        const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');

        const color_id = color_item.dataset.id;
        const color_count = checkSelectedColor(color_id);
        const color_item_count = color_item.querySelector('.color-item-count');

        if (color_count > 0) {
          if (color_item_count) {
            color_item_count.textContent = color_count;
            quantity_color_item_wrapper.classList.remove('hidden');
            add_color_item_button.classList.add('hidden');
          }
        } else {
          if (color_item_count) {
            color_item_count.textContent = 0;
            quantity_color_item_wrapper.classList.add('hidden');
            add_color_item_button.classList.remove('hidden');
          }
        }
      });

      arr.forEach(item => {
        item.style.backgroundColor = "#ffffff";
      });

      current_item.style.backgroundColor = "#F2EBE3";

      const productId = document.getElementById("product-id");
      productId.value = id;
      product_form.dataset.variantId = id;

      // REMOVE PROPERTIES BLOCK      
      const current_properties_block = document.getElementById('nail-picker-properties-block');
      if (current_properties_block) {
        current_properties_block.remove();
      }

      // UPDATE ATC BUTTON AND PROPERTIES BLOCK WITH NEW SELECTED COLORS
      const count = getSelectedCount();
      if (count === colors_number) {
        atc_button_text.style.display = 'flex';
        choose_color_button_text.style.display = 'none';
        main_atc_button.type = 'submit';

        const properties_block = document.createElement('div');
        properties_block.setAttribute('id', 'nail-picker-properties-block');
        
        selected_colors.forEach((color, i) => {
          const isCurrentSelected = color.dataset.selected;

          if (isCurrentSelected) {
            const id = color.dataset.id;

            const text_tag = color.querySelector('p');
            const title = text_tag.textContent;

            const img_tag = color.querySelector('img');
            const image = img_tag.dataset.imageLineItem;

            const hiddenField1 = document.createElement('input');
            hiddenField1.setAttribute('type', "hidden");
            hiddenField1.setAttribute('class', `class${i + 1}`);
            hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
            hiddenField1.setAttribute('value', image);
            properties_block.appendChild(hiddenField1);        

            const hiddenField2 = document.createElement('input');
            hiddenField2.setAttribute('type', "hidden");
            hiddenField2.setAttribute('class', `class${i + 1}`);
            hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
            hiddenField2.setAttribute('value', title);
            properties_block.appendChild(hiddenField2);

            const hiddenField3 = document.createElement('input');
            hiddenField3.setAttribute('type', "hidden");
            hiddenField3.setAttribute('class', `class${i + 1}`);
            hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
            hiddenField3.setAttribute('value', id);
            properties_block.appendChild(hiddenField3);
          }
        });

        product_form.appendChild(properties_block);
      } else {
        atc_button_text.style.display = 'none';
        choose_color_button_text.style.display = 'flex';
        main_atc_button.type = 'button';
      }

      markFirstEmptyPlace();
    });
  });

  // CLICK PRE SELECTED VARIANT
  if (variant_number_pre_selected_number < variantPickerItems.length) {
    variantPickerItems[variant_number_pre_selected_number].click();
  }

  // SET UPGRADE TEXT FOR LAST STEP POPUP AND ADD CLICK EVENTS
  selected_colors_last_step.forEach((color, index) => {
    const data_keys = Object.keys(variants_upgrade_data);

    if (data_keys.length >= 2) {
      if (index >= data_keys[0] && index < data_keys[1] ) {
        color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[0]];
      }
      
      if (index >= data_keys[1]) {
        color.querySelector(".selected-last-step-upgrade").textContent = variants_upgrade_data[data_keys[1]];
      }

      color.addEventListener("click", () => {
        const upgrade_button = color.querySelector(".selected-last-step-upgrade");
        const button_text = upgrade_button.textContent;

        if (button_text.includes(variants_upgrade_data[data_keys[0]]) && !upgrade_button.classList.contains("hidden")) {
          variantPickerItems[1].click();
          nail_picker_last_step_popup.classList.add('hidden');
        }

        if (button_text.includes(variants_upgrade_data[data_keys[1]]) && !upgrade_button.classList.contains("hidden")) {
          variantPickerItems[0].click();
          nail_picker_last_step_popup.classList.add('hidden');
        }
      });
    }
  });

  const scroll_container = document.querySelector(".nail-picker-horizontal-scrollbar-2px");
  function markFirstEmptyPlace() {
    let isMarked = false;

    for (let i = 0; i < selected_colors_inside_picker.length; i++) {
      const color = selected_colors_inside_picker[i];
      const img_element = color.querySelector("img"); 
      color.classList.remove("first-empty-selected-color");
      
      if (i < colors_number) {
        if (!img_element.src && !isMarked) {
          color.classList.add("first-empty-selected-color");

          isMarked = true;

          color.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
    }

    if (!isMarked && scroll_container) {
      scroll_container.scrollBy({
        left: -100,
        behavior: 'smooth'
      });
    }
  }

  // *** NAIL PICKER *** //

  const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
  const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
  const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button');
  const remove_selected_color_items = document.querySelectorAll('.remove-selected-color-item');

  // OPEN COLOR LIST POPUP
  const nail_picker_color_list_wrapper = document.getElementById('nail-picker-color-list-wrapper');
  let is_reset_scroll = false;

  // run scroll to first color item when open nail picker
  function runScroll() {
    if (is_reset_scroll) {
      is_reset_scroll = false;
      
      scroll_container.scrollLeft = 0;
      
      const color_list_slider_wrapper = document.querySelector('.color-list-slider-wrapper');
      color_list_slider_wrapper.scrollTop = 0;
    }

    setTimeout(() => {
      const first_color_item = color_items[0];
      const image_wrapper = first_color_item.querySelector(".nail-picker-color-image-wrapper");
      image_wrapper.scrollTo({ left: 180, behavior: 'smooth' });
  
      setTimeout(() => {
        image_wrapper.scrollTo({ left: 0, behavior: 'smooth' });
      }, 1000);
    }, 1000);
  }
  
  main_atc_button.addEventListener('click', (event) => {
    const current_target = event.currentTarget;
    const button_type = current_target.type;

    if (button_type === 'button') {
      hidden_overlay.classList.remove('hidden');
      nail_picker_color_list_wrapper.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      // setTimeout(() => {
      //   document.addEventListener('click', outsideClickHandler);
      // }, 100);

      runScroll();
    }
  });

  selected_colors.forEach(color => {
    color.addEventListener('click', (event) => {
      hidden_overlay.classList.remove('hidden');
      nail_picker_color_list_wrapper.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      const count = getSelectedCount(); 

      if (count === colors_number) {
        nail_picker_last_step_popup.classList.remove('hidden');
      }

      // setTimeout(() => {
      //   document.addEventListener('click', outsideClickHandler);
      // }, 100);

      runScroll();
    });
  });

  // CLOSE COLOR LIST POPUP
  const nail_picker_color_list_close_popup = document.querySelectorAll('.nail-picker-color-list-close-popup');
  nail_picker_color_list_close_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      hidden_overlay.classList.add('hidden');
      nail_picker_color_list_wrapper.classList.add('hidden');
      document.body.style.overflow = 'auto';
      //document.removeEventListener('click', outsideClickHandler);
    });
  });

  /*function outsideClickHandler(event) {
    if (
      nail_picker_color_list_wrapper &&
      !nail_picker_color_list_wrapper.classList.contains('hidden')
    ) {
      if (!nail_picker_color_list_wrapper.contains(event.target)) {
        nail_picker_color_list_wrapper.classList.add('hidden');
        hidden_overlay.classList.add('hidden');
        document.body.style.overflow = 'auto';
  
        document.removeEventListener('click', outsideClickHandler);
      }
    }
  }*/

  // --- COLOR POPUP --- //
  
  // slider init
  let slider = null;
  function sliderInit(elementId) {
    function sliderNavigation(slider) {
      let controlsWrapper, dots, arrowLeft, arrowRight;
    
      function removeElement(el) {
        el?.parentNode?.removeChild(el);
      }
    
      function createDiv(className) {
        const div = document.createElement("div");
        className.split(" ").forEach(name => div.classList.add(name));
        return div;
      }
    
      function controlsMarkup(remove) {
        if (remove) {
          removeElement(controlsWrapper);
          return;
        }
    
        controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
    
        arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
        arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
    
        arrowLeft.innerHTML = " "; 
        arrowRight.innerHTML = " ";
    
        arrowLeft.addEventListener("click", () => slider.prev());
        arrowRight.addEventListener("click", () => slider.next());
    
        controlsWrapper.appendChild(arrowLeft);
        controlsWrapper.appendChild(arrowRight);
    
        dots = createDiv("product-image-keen-slider-dots");
        const totalSlides = slider.track.details.slides.length;
    
        for (let i = 0; i < totalSlides; i++) {
          const dot = createDiv("product-image-keen-slider-dot");
          dot.addEventListener("click", () => slider.moveToIdx(i));
          dots.appendChild(dot);
        }
    
        controlsWrapper.appendChild(dots);
        slider.container.parentNode.appendChild(controlsWrapper);
      }
    
      function updateClasses() {
        const rel = slider.track.details.rel;
    
        if (dots) {
          Array.from(dots.children).forEach((dot, idx) => {
            dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
          });
        }
    
        if (arrowLeft && arrowRight) {
          const maxIdx = slider.track.details.slides.length - 1;
          arrowLeft.classList.toggle("disabled", rel === 0);
          arrowRight.classList.toggle("disabled", rel === maxIdx);
        }
      }
    
      slider.on("created", () => {
        controlsMarkup();
        updateClasses();
      });
    
      slider.on("slideChanged", updateClasses);
      slider.on("destroyed", () => controlsMarkup(true));
    }
    
    slider = new KeenSlider(
      elementId,
      {
        loop: false,
        slides: { perView: 1, spacing: 16 }
      },
      [sliderNavigation]
    );
  };

  // open nail picker color popup
  nail_picker_color_open_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_popup_id = current_color.dataset.popupId;

      const color_popup = document.getElementById(data_popup_id);
      if (color_popup) {
        color_popup.classList.remove('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'hidden';

        const slider_container = color_popup.querySelector('.keen-slider');

        if (slider_container) {
          sliderInit(slider_container);
        }
      }      
    });
  });

  // close nail picker color popup
  nail_picker_color_close_popup.forEach(item => { 
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;      

      if (slider) {
        slider.destroy();
        slider = null;
      }

      const choose_color_popup = document.getElementById(data_id);
      if (choose_color_popup) {
        choose_color_popup.classList.add('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'auto';
      }
    });
  });

  // --- ADD COLORS TO PICKER --- //

  // get selected count
  function getSelectedCount() {
    let count = 0;
    selected_colors.forEach(color => {
      const isSelected = color.dataset.selected;
      if (isSelected) {
        count++;
      }
    });
    return count;
  }
  
  // add color function
  function addColor(id, image, image_line_item, title) {
    let loop_count = -1;
    for (const color of selected_colors) {
      loop_count++;
      const isSelected = color.dataset.selected;

      if (!isSelected) {
        const img = color.querySelector('img');
        img.setAttribute('src', image);
        img.classList.remove('hidden');
        img.dataset.imageLineItem = image_line_item;        

        const color_name = color.querySelector('p');
        color_name.textContent = title;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'none';

        const remove_button = color.querySelector('.remove-selected-color');
        remove_button.style.display = 'block';
        
        color.dataset.selected = true;
        color.dataset.id = id;        

        const current_selected_color_inside_picker = selected_colors_inside_picker[loop_count];
        if (current_selected_color_inside_picker) {
          const img = current_selected_color_inside_picker.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const plus_icon = current_selected_color_inside_picker.querySelector('span');
          if (plus_icon) {
            plus_icon.style.display = "none";
          }

          const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
          if (remove_button) {
            remove_button.classList.remove('hidden');
          }

          current_selected_color_inside_picker.dataset.id = id;
        }

        const current_selected_color_last_step = selected_colors_last_step[loop_count];
        if (current_selected_color_last_step) {
          const img = current_selected_color_last_step.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const lock_icon = current_selected_color_last_step.querySelector('.lock-icon');
          if (lock_icon) {
            lock_icon.classList.add('hidden');
          }

          const swap_button = current_selected_color_last_step.querySelector('.remove-selected-color-on-last-step');
          if (swap_button) {
            swap_button.classList.remove('hidden');
          }

          const upgrade_button = current_selected_color_last_step.querySelector('.selected-last-step-upgrade');
          if (upgrade_button) {
            upgrade_button.classList.add('hidden');
          }

          current_selected_color_last_step.dataset.id = id;
        }

        const current_selected_color_sticky_atc = selected_colors_sticky_atc[loop_count];
        if (current_selected_color_sticky_atc) {
          const img = current_selected_color_sticky_atc.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const plus_icon = current_selected_color_sticky_atc.querySelector('span');
          if (plus_icon) {
            plus_icon.style.display = "none";
          }
        }

        break;
      }
    }

    const count = getSelectedCount();
    selected_colors_count_on_picker.textContent = count;
    
    const current_properties_block = document.getElementById('nail-picker-properties-block');    

    if (count === colors_number) {
      if (current_properties_block) {
        current_properties_block.remove();
      }
      
      nail_picker_last_step_popup.classList.remove('hidden');

      atc_button_text.style.display = 'flex';
      choose_color_button_text.style.display = 'none';
      main_atc_button.type = 'submit';

      const properties_block = document.createElement('div');
      properties_block.setAttribute('id', 'nail-picker-properties-block');
      
      selected_colors.forEach((color, i) => {
        const is_selected = color.dataset.selected;

        if (is_selected === 'true') {
          const id = color.dataset.id;

          const text_tag = color.querySelector('p');
          const title = text_tag.textContent;

          const img_tag = color.querySelector('img');
          const image = img_tag.dataset.imageLineItem;

          const hiddenField1 = document.createElement('input');
          hiddenField1.setAttribute('type', "hidden");
          hiddenField1.setAttribute('class', `class${i + 1}`);
          hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
          hiddenField1.setAttribute('value', image);
          properties_block.appendChild(hiddenField1);        

          const hiddenField2 = document.createElement('input');
          hiddenField2.setAttribute('type', "hidden");
          hiddenField2.setAttribute('class', `class${i + 1}`);
          hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
          hiddenField2.setAttribute('value', title);
          properties_block.appendChild(hiddenField2);

          const hiddenField3 = document.createElement('input');
          hiddenField3.setAttribute('type', "hidden");
          hiddenField3.setAttribute('class', `class${i + 1}`);
          hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
          hiddenField3.setAttribute('value', id);
          properties_block.appendChild(hiddenField3);
        }
      });

      product_form.appendChild(properties_block);
    }

    markFirstEmptyPlace();
  }

  // add color to picker from color list
  color_items.forEach(color_item => {
    const add_color_item_button = color_item.querySelector('.add-color-item-button');
    const image_wrapper = color_item.querySelector('.nail-picker-color-image-wrapper');

    function tryAddColorFromItem() {
      const data_id = color_item.dataset.id;
      const data_title = color_item.dataset.title;
      const data_image = color_item.dataset.image;
      const data_image_line_item = color_item.dataset.imageLineItem;
      const current_selected_colors = getSelectedCount();

      if (current_selected_colors >= colors_number) return;

      if (add_color_item_button) {
        add_color_item_button.classList.add('hidden');
      }
      const quantity_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
      if (quantity_wrapper) {
        quantity_wrapper.classList.remove('hidden');
      }

      addColor(data_id, data_image, data_image_line_item, data_title);

      const color_count = checkSelectedColor(data_id);
      const color_item_count = color_item.querySelector('.color-item-count');
      if (color_item_count) {
        color_item_count.textContent = color_count;
      }
    }

    if (add_color_item_button) {
      add_color_item_button.addEventListener('click', (event) => {
        tryAddColorFromItem();
      });
    }

    // Клик/тап по картинке добавляет цвет так же, как кнопка (без срабатывания при скролле слайдера)
    if (image_wrapper) {
      let pointerDownX = 0;
      let pointerDownY = 0;

      image_wrapper.addEventListener('pointerdown', (e) => {
        pointerDownX = e.clientX;
        pointerDownY = e.clientY;
      }, { passive: true });

      image_wrapper.addEventListener('click', (e) => {
        const moveThreshold = 10;
        if (Math.abs(e.clientX - pointerDownX) > moveThreshold || Math.abs(e.clientY - pointerDownY) > moveThreshold) {
          return;
        }
        tryAddColorFromItem();
      });
    }

    const add_color_item_button_plus = color_item.querySelector('.color-item-count-plus');
    if (add_color_item_button_plus) {
      add_color_item_button_plus.addEventListener('click', () => {
        const current_color = color_item;
        const data_id = current_color.dataset.id;
        const data_title = current_color.dataset.title;
        const data_image = current_color.dataset.image;
        const data_image_line_item = current_color.dataset.imageLineItem;

        const current_selected_colors = getSelectedCount();

        if (current_selected_colors < colors_number) {
          addColor(data_id, data_image, data_image_line_item, data_title);
          
          const color_count = checkSelectedColor(data_id);
          const color_item_count = current_color.querySelector('.color-item-count');

          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        }
      });
    }
  });

  // add color to picker from color popup
  nail_picker_color_popup_add_buttons.forEach(item => {
    item.addEventListener('click', (event) => {
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;
      const data_title = current_color.dataset.title;
      const data_image = current_color.dataset.image;
      const data_image_line_item = current_color.dataset.imageLineItem;
      const data_popup_id = current_color.dataset.popupId;

      const current_selected_colors_count = getSelectedCount();

      if (current_selected_colors_count < colors_number) {
        addColor(data_id, data_image, data_image_line_item, data_title);

        const color_item = document.querySelector(`.nail-picker-color[data-id="${data_id}"]`);
        if (color_item) {
          color_item.querySelector('.add-color-item-button').classList.add('hidden');
          color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

          const color_count = checkSelectedColor(data_id);
          const color_item_count = color_item.querySelector('.color-item-count');

          if (color_item_count) {
            color_item_count.textContent = color_count;
          }
        } else {
          console.warn('Color item not found for id:', data_id);
        }
      }
      
      const color_popup = document.getElementById(data_popup_id);
      color_popup.classList.add('hidden');

      if (slider) {
        slider.destroy();
        slider = null;
      }
    });
  });  

  // --- REMOVE COLORS FROM PICKER --- //
  
  // remove line item properties
  function removeProperties() {
    const current_properties_block = document.getElementById('nail-picker-properties-block');

    if (current_properties_block) {
      current_properties_block.remove();
      
      atc_button_text.style.display = 'none';
      choose_color_button_text.style.display = 'flex';
      main_atc_button.type = 'button';
    }
  }

  function checkSelectedColor(data_id) {
    let selected_count = 0;

    for (const color of selected_colors) {
      const color_id = color.dataset.id;

      if (color_id === data_id) {
        selected_count++;
      }
    }

    return selected_count;
  }

  // remove buttons on color items
  remove_selected_color_items.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_item = event.currentTarget;
      const parent = current_item.closest('.nail-picker-color'); 
      const data_id = current_item.dataset.id;

      let selected_index;
      selected_colors.forEach((color, index) => {
        if (color.dataset.id === data_id) {
          selected_index = index;
        }
      });

      // REMOVE FROM MAIN SELECTED COLORS LIST
      const current_selected_color = selected_colors[selected_index];
      if (current_selected_color) {
        const img = current_selected_color.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        current_selected_color.removeAttribute('data-selected');
        current_selected_color.removeAttribute('data-id');

        const color_name = current_selected_color.querySelector('p');
        color_name.textContent = `${placeholder_color_name} ${selected_index + 1}`;

        const plus_icon = current_selected_color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = current_selected_color.querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
      }

      // REMOVE FROM STICKY ATC SELECTED COLORS LIST
      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[selected_index];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
        if (plus_icon) {
          plus_icon.style.display = "block";
        }
      }

      // REMOVE FROM INSIDE PICKER SELECTED COLORS LIST
      const current_selected_color_inside_picker = selected_colors_inside_picker[selected_index];
      if (current_selected_color_inside_picker) {
        const img = current_selected_color_inside_picker.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const icon_plus = current_selected_color_inside_picker.querySelector('span');
        if (icon_plus) {
          icon_plus.style.display = "block";
        }

        const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
        if (remove_button) {
          remove_button.classList.add('hidden');
        }
      }

      // REMOVE FROM COLOR ITEM LIST
      const color_item_count = parent.querySelector('.color-item-count');
      const color_count = checkSelectedColor(data_id);
      if (color_count > 0) {
        color_item_count.textContent = color_count;
        parent.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
        parent.querySelector('.add-color-item-button').classList.add('hidden');
      } else {
        color_item_count.textContent = 0;
        parent.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
        parent.querySelector('.add-color-item-button').classList.remove('hidden');
      }   

      removeProperties();
      selected_colors_count_on_picker.textContent = getSelectedCount();
      markFirstEmptyPlace();
    });
  });

  // remove buttons on selected colors
  remove_selected_colors.forEach((item, i) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const parent = current_color.parentElement;
      const color_id = parent.dataset.id;

      const img = parent.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const color_name = parent.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${i + 1}`;

      const plus_icon = parent.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = parent.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';
      
      parent.removeAttribute('data-selected');
      parent.removeAttribute('data-id');

      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[i];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
        if (plus_icon) {
          plus_icon.style.display = "block";
        }
      }

      const current_selected_colors_color_list = selected_colors_inside_picker[i];
      if (current_selected_colors_color_list) {
        const img = current_selected_colors_color_list.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const icon_plus = current_selected_colors_color_list.querySelector('span');
        if (icon_plus) {
          icon_plus.style.display = "block";
        }

        const remove_button = current_selected_colors_color_list.querySelector('.remove-selected-color-on-picker');
        if (remove_button) {
          remove_button.classList.add('hidden');
        }

        current_selected_colors_color_list.removeAttribute('data-id');
      }      

      // REMOVE FROM COLOR ITEM LIST
      const color_item = document.querySelector(`.nail-picker-color[data-id="${color_id}"]`);
      if (color_item) {
        const color_item_count = color_item.querySelector('.color-item-count');
        const color_count = checkSelectedColor(color_id);

        if (color_count > 0) {        
          color_item_count.textContent = color_count;
          color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
          color_item.querySelector('.add-color-item-button').classList.add('hidden');
        } else {
          color_item_count.textContent = 0;
          color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
          color_item.querySelector('.add-color-item-button').classList.remove('hidden');
        }
      }

      removeProperties();
      selected_colors_count_on_picker.textContent = getSelectedCount();
      markFirstEmptyPlace();
    });
  });

  // remove buttons on selected colors on picker
  remove_selected_colors_on_picker.forEach((item, i) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_button = event.currentTarget;
      const parent = current_button.parentElement;
      const color_id = parent.dataset.id;

      const img = parent.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const plus_icon = parent.querySelector('span');
      if (plus_icon) {
        plus_icon.style.display = "block";
      }

      const remove_button = parent.querySelector('.remove-selected-color-on-picker'); 
      if (remove_button) {
        remove_button.classList.add('hidden');
      }
      
      parent.removeAttribute('data-id');

      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[i];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
        if (plus_icon) {
          plus_icon.style.display = "block";
        }
      }

      const current_selected_color = selected_colors[i];
      if (current_selected_color) {
        const img = current_selected_color.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        current_selected_color.removeAttribute('data-selected');
        current_selected_color.removeAttribute('data-id');

        const color_name = current_selected_color.querySelector('p');
        color_name.textContent = `${placeholder_color_name} ${i + 1}`;

        const plus_icon = current_selected_color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = current_selected_color.querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
      }

      // REMOVE FROM COLOR ITEM LIST
      const color_item = document.querySelector(`.nail-picker-color[data-id="${color_id}"]`);
      if (color_item) {
        const color_item_count = color_item.querySelector('.color-item-count');
        const color_count = checkSelectedColor(color_id);

        if (color_count > 0) {        
          color_item_count.textContent = color_count;
          color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
          color_item.querySelector('.add-color-item-button').classList.add('hidden');
        } else {
          color_item_count.textContent = 0;
          color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
          color_item.querySelector('.add-color-item-button').classList.remove('hidden');
        }
      }

      removeProperties();
      selected_colors_count_on_picker.textContent = getSelectedCount();
      markFirstEmptyPlace();
    });
  });

  // remove buttons on selected colors on last step
  remove_selected_colors_on_last_step.forEach((item, i) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_button = event.currentTarget;
      const parent = current_button.parentElement;
      const color_id = parent.dataset.id;      

      const img = parent.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const lock_icon = parent.querySelector('.lock-icon');
      if (lock_icon) {
        lock_icon.classList.remove('hidden');
      }
      
      parent.removeAttribute('data-id');
      nail_picker_last_step_popup.classList.add('hidden');

      // REMOVE FROM MAIN SELECTED COLORS LIST
      const current_selected_color = selected_colors[i];
      if (current_selected_color) {
        const img = current_selected_color.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }        

        const color_name = current_selected_color.querySelector('p');
        color_name.textContent = `${placeholder_color_name} ${i + 1}`;

        const plus_icon = current_selected_color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = current_selected_color.querySelector('.remove-selected-color');
        remove_button.style.display = 'none';

        current_selected_color.removeAttribute('data-selected');
        current_selected_color.removeAttribute('data-id');
      }

      // REMOVE FROM INSIDE PICKER SELECTED COLORS LIST
      const current_selected_color_inside_picker = selected_colors_inside_picker[i];
      if (current_selected_color_inside_picker) {
        const img = current_selected_color_inside_picker.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const icon_plus = current_selected_color_inside_picker.querySelector('span');
        if (icon_plus) {
          icon_plus.style.display = "block";
        }

        const remove_button = current_selected_color_inside_picker.querySelector('.remove-selected-color-on-picker');
        if (remove_button) {
          remove_button.classList.add('hidden');
        }

        current_selected_color_inside_picker.removeAttribute('data-id');
      }

      // REMOVE FROM STICKY ATC SELECTED COLORS LIST
      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[i];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const plus_icon = current_selected_colors_sticky_atc.querySelector('span');
        if (plus_icon) {
          plus_icon.style.display = "block";
        }
      }
      
      // REMOVE FROM COLOR ITEM LIST
      const color_item = document.querySelector(`.nail-picker-color[data-id="${color_id}"]`);
      if (color_item) {
        const color_item_count = color_item.querySelector('.color-item-count');
        const color_count = checkSelectedColor(color_id);

        if (color_count > 0) {        
          color_item_count.textContent = color_count;
          color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');
          color_item.querySelector('.add-color-item-button').classList.add('hidden');
        } else {
          color_item_count.textContent = 0;
          color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
          color_item.querySelector('.add-color-item-button').classList.remove('hidden');
        }
      }

      removeProperties();
      selected_colors_count_on_picker.textContent = getSelectedCount();
      markFirstEmptyPlace();
    });
  });

  // NAIL PICKER FILTER
  const nail_picker_filter_open_button = document.getElementById("nail-picker-filter-button");
  const filter_wrapper = document.getElementById("filter-wrapper");
  const nail_picker_shevrons_close_filter = document.getElementById("nail-picker-shevrons-close-filter"); 
  const nail_picker_shevrons_open_filter = document.getElementById("nail-picker-shevrons-open-filter"); 
  nail_picker_filter_open_button.addEventListener("click", () => {
    filter_wrapper.classList.toggle("hidden");

    if (filter_wrapper.classList.contains("hidden")) {
      nail_picker_shevrons_close_filter.classList.remove("hidden");
      nail_picker_shevrons_open_filter.classList.add("hidden");
      nail_picker_filter_open_button.classList.remove("nail-picker-filter-button-active");
    } else {
      nail_picker_shevrons_close_filter.classList.add("hidden");
      nail_picker_shevrons_open_filter.classList.remove("hidden");
      nail_picker_filter_open_button.classList.add("nail-picker-filter-button-active");
    }
  });

  const selected_color_filter_values = [];
  const selected_category_filter_values = [];

  // COLOR FILTER
  const filter_buttons = document.querySelectorAll('.nail-picker-color-filter-item');
  filter_buttons.forEach(item => {
    item.addEventListener('click', (event) => {
      const current_color = event.currentTarget;
      const data_value = current_color.dataset.value;

      const remove_button = current_color.querySelector('.nail-picker-color-filter-item-remove');

      if (remove_button.classList.contains('hidden')) {
        selected_color_filter_values.push(data_value);
        remove_button.classList.remove('hidden');
        current_color.classList.add('border-[1.5px]');
        current_color.classList.add('border-[#000000]');
      } else {
        remove_button.classList.add('hidden');
        selected_color_filter_values.splice(selected_color_filter_values.indexOf(data_value), 1);
        current_color.classList.remove('border-[1.5px]');
        current_color.classList.remove('border-[#000000]'); 
      }
      
      setFilter();
    });
  });

  // CATEGORY FILTER
  const category_filter_buttons = document.querySelectorAll('.nail-picker-category-filter-item');
  category_filter_buttons.forEach(item => {
    item.addEventListener('click', (event) => {
      const current_category = event.currentTarget;
      const data_value = current_category.dataset.value;

      const remove_button = current_category.querySelector('.nail-picker-category-filter-item-remove');

      if (remove_button.classList.contains('hidden')) {
        selected_category_filter_values.push(data_value);
        remove_button.classList.remove('hidden');
        current_category.classList.add('nail-picker-category-filter-item-active');
      } else {
        remove_button.classList.add('hidden');
        selected_category_filter_values.splice(selected_category_filter_values.indexOf(data_value), 1);
        current_category.classList.remove('nail-picker-category-filter-item-active');
      }
      
      setFilter();
    });
  });

  function setFilter() {
    color_items.forEach((color_item) => {
      const data_color_filter = color_item.dataset.colorFilter;
      const data_category_filter = color_item.dataset.categoryFilter;
      const data_id = color_item.dataset.id;
      let is_show = false;

      if (selected_category_filter_values.length > 0) {
        const color_category_values = data_category_filter.split(',');
        for (const color_category_value of color_category_values) {
          if (selected_category_filter_values.includes(color_category_value)) {
            is_show = true;
            break;
          } else {
            is_show = false;
          }
        }
      } else {
        is_show = true;
      }
      
      if (selected_color_filter_values.length > 0 && is_show) {
        const color_filter_values = data_color_filter.split(',');
        for (const color_filter_value of color_filter_values) {
          if (selected_color_filter_values.includes(color_filter_value)) {
            is_show = true;
            break;
          } else {
            is_show = false;
          }
        }
      }

      if (is_show) {
        color_item.classList.remove('hidden');
      } else {
        color_item.classList.add('hidden');
      }
    });
  }

  // LAST STEP POPUP CLOSE BUTTON
  const nail_picker_last_step_close_popup = document.querySelector(".nail-picker-last-step-close-popup");
  nail_picker_last_step_close_popup.addEventListener('click', () => {
    hidden_overlay.classList.add('hidden');
    nail_picker_last_step_popup.classList.add('hidden');
    nail_picker_color_list_wrapper.classList.add("hidden");
    document.body.style.overflow = "auto";
  });

  // LAST STEP POPUP ADD TO CART BUTTON
  const nail_picker_last_step_atc_button = document.querySelector('.nail-picker-last-step-atc-button');
  nail_picker_last_step_atc_button.addEventListener('click', () => {
    main_atc_button.click();

    hidden_overlay.classList.add('hidden');
    nail_picker_last_step_popup.classList.add('hidden');
    nail_picker_color_list_wrapper.classList.add("hidden");
    document.body.style.overflow = "auto";
  });

  // CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART - working in cart drawer
  window.clearNailPickerGelWraps = function() {
    selected_colors.forEach((item, i) => {
      const img = item.querySelector('img');
      img.removeAttribute('src');
      img.classList.add('hidden');
      img.style.opacity = '1';

      const color_name = item.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${i + 1}`;

      const plus_icon = item.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = item.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';

      const lock_icon = item.querySelector(".lock-icon");
      lock_icon.style.display = 'none';
      
      item.removeAttribute('data-selected');
      item.removeAttribute('data-id');
      
      const image_wrapper = item.firstElementChild;
      image_wrapper.style.backgroundColor = "#ffffff";
      image_wrapper.style.borderColor = "#211912B2";
    });

    selected_colors_sticky_atc.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const plus_icon = item.querySelector('span');
      if (plus_icon) {
        plus_icon.style.display = 'block';
      }

      const lock_icon = item.querySelector('.lock-icon');
      if (lock_icon) {
        lock_icon.style.display = 'none';
      }

      item.style.backgroundColor = "#ffffff";
      item.style.borderColor = "#211912B2";
    });

    selected_colors_inside_picker.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const plus_icon = item.querySelector('span');
      if (plus_icon) {
        plus_icon.style.display = "block";
      }

      const remove_button = item.querySelector('.remove-selected-color-on-picker');
      if (remove_button) {
        remove_button.classList.add('hidden');
      }

      item.removeAttribute('data-id');
    });    

    color_items.forEach(color_item => {
      const color_item_count = color_item.querySelector('.color-item-count');
      if (color_item_count) {
        color_item_count.textContent = 0;
      }

      const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
      if (quantity_color_item_wrapper) {
        quantity_color_item_wrapper.classList.add('hidden');
      }

      const add_color_item_button = color_item.querySelector('.add-color-item-button');
      if (add_color_item_button) {
        add_color_item_button.classList.remove('hidden');
      }
    });

    removeProperties();

    variantPickerItems[variant_number_pre_selected_number].click();

    is_reset_scroll = true;
  }
});
